import { Drawer, Form, Input } from "antd";
import React, { useEffect, useState } from "react";


import Select from 'react-select';
import { toast, ToastContainer } from "react-toastify";
import { getEmployees } from "../../../lib/getEmployees";
import { updateEmployee } from "../../../lib/updateEmployee";

const EditEmployee = ({
  setEmployeeList,
  openDrawer,
  setOpenDrawer,
  selectedEmployee,
  setSelectedEmployee,
}) => {
  const notifyBottomRight = () => {
    toast.success("✔️ Empleado editado exitosamente.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
    });
  };
  const [tipoAporte, setTipoAporte] = useState({value: 'sindical', label: 'Sindical' }); // tipo de aporte

  const [form] = Form.useForm();

  
  const handleSelectChange = (selectedOption) => {
    debugger
    setTipoAporte(selectedOption);
};
  useEffect(() => {
    const fetchEmployees = async () => {
      const { companyProfile } = JSON.parse(
        window.localStorage.getItem("userDetails")
      );
      form.resetFields();
      try {
        const res = await getEmployees(companyProfile._id);
        setEmployeeList(res.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchEmployees();
  }, []);

  useEffect(() => {
    debugger
    if (selectedEmployee?.tipo_aporte) {
      switch (selectedEmployee.tipo_aporte) {
        case "sindical":
          selectedEmployee.tipo_aporte={ value: "sindical", label: "Sindical" };
          break;
        case "formacion":
          selectedEmployee.tipo_aporte={ value: "formacion", label: "Por Formación" };
          break;
        case "ambas":
          selectedEmployee.tipo_aporte={ value: "ambas", label: "Sindical y Por Formación" };
          break;
        default:
          selectedEmployee.tipo_aporte={ value: "sindical", label: "Sindical" };
      }
      debugger
      setTipoAporte(selectedEmployee?.tipo_aporte)
    }
   
  }, [selectedEmployee]);
  return (
    <>
      <ToastContainer />
      <Drawer
        style={{
          backgroundColor: "#362465",
          borderTopLeftRadius: "15px",
          borderBottomLeftRadius: "15px",
        }}
        destroyOnClose
        width={500}
        title={<label style={{ color: "white" }}>Editar empleado</label>}
        placement={"right"}
        onClose={() => {
          setSelectedEmployee();
          form.resetFields();
          setOpenDrawer(false);
        }}
        closable={false}
        open={openDrawer}
        key={"right"}
      >
        <Form
          preserve={false}
          size="small"
          name="employee"
          layout="vertical"
          form={form}
          onFinish={(v) => {
            debugger
            v.employee.tipo_aporte = v.employee.tipo_aporte?.value;
            updateEmployee(v.employee).then((res) => {

              debugger
              const { status } = res;
              const { companyProfile } = JSON.parse(
                window.localStorage.getItem("userDetails")
              );
              getEmployees(companyProfile._id).then((res) => {
                setEmployeeList(res.data);
              });
              if (status) {
                notifyBottomRight();
              }
              form.resetFields();
              setOpenDrawer(false);
            });
          }}
        >
          <Form.Item
            style={{ color: "white" }}
            initialValue={selectedEmployee && selectedEmployee.cuil}
            name={["employee", "cuil"]}
            label={<label style={{ color: "white" }}>CUIL</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            initialValue={selectedEmployee && selectedEmployee.name}
            name={["employee", "name"]}
            label={<label style={{ color: "white" }}>Apellido y Nombre</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            initialValue={selectedEmployee && selectedEmployee.dni}
            name={["employee", "dni"]}
            label={<label style={{ color: "white" }}>DNI</label>}
            rules={[
              {
                required: true,
                pattern: new RegExp(/^[0-9]+$/),
              },
            ]}
          >
            <Input type="numeric" />
          </Form.Item>

          {/* <Form.Item
            initialValue={selectedEmployee && selectedEmployee.charge}
            name={["employee", "charge"]}
            label={<label style={{ color: "white" }}>Cargo</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item> */}

          <Form.Item
            initialValue={selectedEmployee && selectedEmployee.email}
            name={["employee", "email"]}
            label={<label style={{ color: "white" }}>Email</label>}
            rules={[
              {
                required: true,
                type: "email",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            initialValue={selectedEmployee && selectedEmployee.phoneNumber}
            name={["employee", "phoneNumber"]}
            label={<label style={{ color: "white" }}>Teléfono</label>}
            rules={[
              {
                required: true,
                pattern: new RegExp(/^[0-9]+$/),
              },
            ]}
          >
            <Input type="numeric" />
          </Form.Item>

          {/* <Form.Item
            initialValue={selectedEmployee && selectedEmployee.place}
            name={["employee", "place"]}
            label={<label style={{ color: "white" }}>Lugar de trabajo</label>}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item> */}

          <Form.Item
            initialValue={selectedEmployee && selectedEmployee.salary}
            name={["employee", "salary"]}
            label={<label style={{ color: "white" }}>Salario bruto</label>}
            rules={[
              {
                required: true,
                pattern: /^\d+(\.\d{1,2})?$/,
              },
            ]}
          >
            <Input type="numeric" />
          </Form.Item>
          <Form.Item
            initialValue={tipoAporte}
            name={["employee", "tipo_aporte"]}
            label={<label style={{ color: "white" }}>Tipo Aporte</label>}
          >
             <Select 
             
                className="custom-react-select"
                options={[
                    { value: 'sindical', label: 'Sindical' },
                    { value: 'formacion', label: 'Por Formacion' },
                    { value: 'ambas', label: 'Ambos Aportes' },
                   
                ]}
                value={tipoAporte ?? {}}
                onChange={(selectedOption) => handleSelectChange(selectedOption)}
                isSearchable={true}
            />
          </Form.Item>

          <div
            style={{
              justifyContent: "space-between",
              display: "flex",
              marginTop: "25%",
            }}
          >
            <Form.Item>
              <button
                style={{ width: "210px" }}
                type="primary"
                htmlType="submit"
                className="btn btn-primary"
              >
                Guardar
              </button>
            </Form.Item>
            <Form.Item>
              <button
                style={{ width: "210px" }}
                type="primary"
                className="btn btn-danger"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenDrawer(false);
                }}
              >
                Cancelar
              </button>
            </Form.Item>
          </div>
        </Form>
      </Drawer>
    </>
  );
};

export default EditEmployee;
